const s3 = 'https://s3.amazonaws.com'
const backet = process.env.REACT_APP_BACKET
const jobsFolder = 'job-pics'

export default (id, fileName) =>
  `${s3}/${backet}/${jobsFolder}/${id}/${fileName}`
